const accountFiles = "account-files";
const visitSummary = "visit-summary";

const queryKeys = {
    accountFiles,
    visitSummary,
} as const;

export default queryKeys;
